'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var TextLink = require('@narvar/nth-bit-text-link');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const templateLinkContext = (href, linkStyle, linkHoverStyle) => {
  const MarketingLink = ({
    children
  }) => /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    key: href,
    linkStyle: {
      sDefault: linkStyle,
      sHover: linkHoverStyle
    },
    href: href ?? ''
  }, children);
  return MarketingLink;
};

exports.templateLinkContext = templateLinkContext;
